import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "ytb-access-dialog__field"
};
const _hoisted_2 = ["disabled"];
const _hoisted_3 = {
  key: 0,
  class: "ytb-access-dialog__error"
};
const _hoisted_4 = {
  class: "ytb-access-dialog__footer"
};
const _hoisted_5 = ["disabled"];
import { computed, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useYtbAccessStore } from '@/stores/modules/ytb-access.store.js';
export default {
  __name: 'YtbAccessDialog',
  setup(__props) {
    const store = useYtbAccessStore();
    const {
      dialogVisible,
      unlocking,
      unlockError
    } = storeToRefs(store);
    const visible = computed({
      get: () => dialogVisible.value,
      set: val => {
        dialogVisible.value = val;
      }
    });
    const password = ref('');
    const pwdRef = ref(null);
    watch(dialogVisible, open => {
      if (!open) {
        password.value = '';
        return;
      }
      unlockError.value = '';
      requestAnimationFrame(() => pwdRef.value?.focus());
    });
    async function submit() {
      const ok = await store.unlock(password.value);
      if (ok) password.value = '';
    }
    function onBackHome() {
      store.dialogVisible = false;
    }
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: visible.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => visible.value = $event),
        class: "ytb-access-dialog",
        "modal-class": "ytb-access-dialog-overlay",
        width: "440px",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "show-close": false,
        "append-to-body": ""
      }, {
        header: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createElementVNode("div", {
          class: "ytb-access-dialog__hero"
        }, [_createElementVNode("div", {
          class: "ytb-access-dialog__orbs",
          "aria-hidden": "true"
        }, [_createElementVNode("span", {
          class: "ytb-access-dialog__orb ytb-access-dialog__orb--1"
        }), _createElementVNode("span", {
          class: "ytb-access-dialog__orb ytb-access-dialog__orb--2"
        })]), _createElementVNode("span", {
          class: "ytb-access-dialog__badge"
        }, "短视频 · AI 出片"), _createElementVNode("h2", {
          class: "ytb-access-dialog__title"
        }, "访问验证"), _createElementVNode("p", {
          class: "ytb-access-dialog__subtitle"
        }, "请输入访问密码，解锁工具箱子页")], -1)]))]),
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_router_link, {
          to: "/ytb",
          class: "ytb-access-dialog__back",
          onClick: onBackHome
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("返回首页", -1)]))]),
          _: 1
        }), _createElementVNode("button", {
          type: "button",
          class: "ytb-access-dialog__btn",
          disabled: _unref(unlocking),
          onClick: submit
        }, _toDisplayString(_unref(unlocking) ? '验证中...' : '进入工具箱'), 9, _hoisted_5)])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_cache[3] || (_cache[3] = _createElementVNode("span", {
          class: "ytb-access-dialog__field-icon",
          "aria-hidden": "true"
        }, "🔐", -1)), _withDirectives(_createElementVNode("input", {
          ref_key: "pwdRef",
          ref: pwdRef,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => password.value = $event),
          type: "password",
          class: "ytb-access-dialog__input",
          placeholder: "请输入访问密码",
          autocomplete: "off",
          disabled: _unref(unlocking),
          onKeydown: _withKeys(submit, ["enter"])
        }, null, 40, _hoisted_2), [[_vModelText, password.value]])]), _unref(unlockError) ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(unlockError)), 1)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};